import { useState, MouseEvent } from "react";
import MoreVert from "@material-ui/icons/MoreVert";
import Edit from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { useTableActionStyles } from "./styles";
import ServiceFormUpdate from "../../../form/update";
import { AttendanceLocalService } from "../../../../../../../../../@types/attendance-local-service";
import ServiceDelete from "../../../delete";

type ServiceTableActionsProps = {
  service: AttendanceLocalService;
};

export default function ServiceTableActions({
  service,
}: ServiceTableActionsProps) {
  //   const { pathname } = useLocation();
  const { classes } = useTableActionStyles();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <MoreVert />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
      >
        {/* <MenuItem
          component={Link}
          onClick={handleClose}
          className={classes.menuItem}
          href={`${pathname}/setor/${service.id}`}
        >
          <Info htmlColor="#706E7A" />
          Informações
        </MenuItem> */}
        <ServiceFormUpdate
          service={service}
          slug={service.unidade}
          buttonTrigger={
            <MenuItem onClick={handleClose} className={classes.menuItem}>
              <Edit htmlColor="#706E7A" />
              Editar
            </MenuItem>
          }
        />
        <ServiceDelete
          service={service}
          buttonTrigger={
            <MenuItem onClick={handleClose} className={classes.menuItem}>
              <Delete htmlColor="#706E7A" />
              Excluir
            </MenuItem>
          }
        />
      </Menu>
    </>
  );
}
